export class HistoryObjectLogTypeNames {
  public static readonly goal = 'Goal';
  public static readonly campaign = 'Campaign';
  public static readonly program = 'Program';
  public static readonly expense = 'Expense';
  public static readonly metricMapping = 'MetricMapping';
}

export type HistoryObjectLogType = 'Goal' | 'Campaign' | 'Program' | 'Expense' | 'MetricMapping';
